<template>
  <div>
    <el-input ref="reference" readonly :value="labelValue" @click.native.stop="handleFocus" />
    <transition
      name="el-zoom-in-top"
      @after-leave="doDestroy"
    >
      <Dropdown v-show="visible" ref="popper" :append-to-body="popperAppendToBody">
        <div class="area-picker-popper" @click.stop>
          <el-tabs
            v-model="areaLevel"
            :before-leave="beforeLeave"
          >
            <el-tab-pane label="省份" name="province">
              <div class="area-picker-province">
                <div
                  v-for="(type, index) in ['A-G', 'H-K', 'L-S', 'T-Z']"
                  :key="index"
                  class="area-picker-province-type"
                >
                  <div class="area-picker-province-title">{{ type }}</div>
                  <div class="area-picker-province-content">
                    <div
                      v-for="item in districts[type] || []"
                      :key="item.code"
                      class="area-picker-province-cell"
                    >
                      <el-tag
                        style="cursor: pointer;border: none;line-height: 24px;"
                        size="small"
                        :effect="province.code === item.code ? 'dark' : 'plain'"
                        :type="province.code === item.code ? '' : 'info'"
                        :title="item.address"
                        @click="chooseProvince(item)"
                      >
                        {{ item.address }}
                      </el-tag>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="showCity" label="城市" name="city">
              <div class="area-picker-city">
                <div
                  v-for="item in cityData"
                  :key="item.code"
                  class="area-picker-cell"
                >
                  <el-tag
                    style="cursor: pointer;border: none;line-height: 24px;"
                    size="small"
                    :effect="city.code === item.code ? 'dark' : 'plain'"
                    :type="city.code === item.code ? '' : 'info'"
                    :title="item.address"
                    @click="chooseCity(item)"
                  >
                    {{ item.address }}
                  </el-tag>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="showDistrict" label="区/县" name="district">
              <div class="area-picker-district">
                <div
                  v-for="item in districtData"
                  :key="item.code"
                  class="area-picker-cell"
                >
                  <el-tag
                    style="cursor: pointer;border: none;line-height: 24px;"
                    size="small"
                    :effect="district.code === item.code ? 'dark' : 'plain'"
                    :type="district.code === item.code ? '' : 'info'"
                    :title="item.address"
                    @click="chooseDistrict(item)"
                  >
                    {{ item.address }}
                  </el-tag>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </Dropdown>
    </transition>
  </div>
</template>

<script>
import http from '@/plugin/axios'
import { districts } from './config'
import Dropdown from './dropdown.vue'
export default {
  components: {
    Dropdown
  },
  props: {
    value: {
      type: null,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    level: {
      type: String,
      default: 'district'
    }
  },
  data() {
    return {
      province: {},
      city: {},
      district: {},
      areaLevel: 'province',
      labelValue: '',
      codeValue: '',
      visible: false,
      cityData: [],
      districtData: []
    }
  },
  computed: {
    districts() {
      return districts
    },
    showCity() {
      return ['city', 'district'].includes(this.level)
    },
    showDistrict() {
      return ['district'].includes(this.level)
    }
  },
  created() {
    if (this.value) {
      this.codeValue = this.value
      this.labelValue = `${this.data.provinceName}/${this.data.cityName}/${this.data.areaName}`
    }
  },
  methods: {
    handleFocus(event) {
      this.visible = true
      this.$emit('focus', event)
      setTimeout(() => {
        document.addEventListener('click', this.closePopper)
      }, 300)
    },
    closePopper() {
      this.visible = false
      document.removeEventListener('click', this.closePopper)
    },
    beforeLeave(name) {
      if (name === 'city' && !this.province.code) {
        return false
      }
      if (name === 'district' && !this.city.code) {
        return false
      }
    },
    doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy()
    },

    chooseProvince(province) {
      this.changeProvince(province)
      this.selectTab('province')
    },
    async changeProvince(province) {
      if (province.code === this.province.code) return
      this.province = { address: province.address, code: province.code }
      this.city = {}
      this.district = {}
      const cityData = await http({
        url: '/sysArea/getSysAreaList',
        baseURL: process.env.VUE_APP_BASE_API,
        data: { condition: { lvl: 1, id: province.code }, size: 100, current: 1 }
      })
      this.cityData = Object.freeze(cityData.records.map(item => ({ code: item.id, address: item.name })))
      if (this.showCity) {
        this.areaLevel = 'city'
      }
    },
    chooseCity(city) {
      this.changeCity(city)
      this.selectTab('city')
    },
    async changeCity(city) {
      if (city.code === this.city.code) return
      this.city = { address: city.address, code: city.code }
      this.district = {}
      const districtData = await http({
        url: '/sysArea/getSysAreaList',
        baseURL: process.env.VUE_APP_BASE_API,
        data: { condition: { lvl: 2, id: city.code }, size: 100, current: 1 }
      })
      this.districtData = Object.freeze(districtData.records.map(item => ({ code: item.id, address: item.name })))
      if (this.showDistrict) {
        this.areaLevel = 'district'
      }
    },
    chooseDistrict(district) {
      this.changeDistrict(district)
      this.selectTab('district')
    },
    changeDistrict(district) {
      this.district = { address: district.address, code: district.code }
    },
    selectTab(type) {
      this.changeValue(type)
      this.$emit(
        'tab',
        this.codeValue,
        {
          level: type,
          province: { ...this.province },
          city: { ...this.city },
          district: { ...this.district }
        }
      )
      if (this.level === type) {
        this.$refs.popover && this.$refs.popover.doClose()
      }
    },
    changeValue(type, outside) {
      const { code } = this[type]
      if (this.codeValue !== code) {
        this.labelValue = [this.province.address, this.city.address, this.district.address].filter(i => i).join('/')
        this.codeValue = code
        if (this.level === type) {
          this.$emit('input', this.codeValue)
          this.visible = false
          if (!outside) {
            this.$nextTick(() => {
              this.$emit(
                'change',
                this.codeValue,
                {
                  level: type,
                  province: { ...this.province },
                  city: { ...this.city },
                  district: { ...this.district }
                }
              )
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.area-picker {
  &-popper {
    width: 400px;
    padding: 10px;
  }

  &__caret {
    transform: rotate(180deg);
    &.is-reverse {
      transform: rotate(0);
    }
  }
  &-province {
    width: 400px;
    &-type {
      display: flex;
    }
    &-title {
      width: 30px;
      min-width: 30px;
      text-align: right;
      padding: 4px 0;
      line-height: 36px;
    }
    &-content {
      flex-grow: 1;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    &-cell {
      width: 20%;
      text-align: center;
      padding: 4px 0;
    }
  }
  &-city, &-district {
    width: 400px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  &-city{
    width: 400px;
  }
  &-cell {
    width: 25%;
    padding: 4px 10px;
    box-sizing: border-box;
  }
}
</style>
